export default {
  plans: {
    1: {
      en: 'One per month',
    },
    2: {
      en: 'Two per month',
    },
    3: {
      en: 'Three per month',
    },
  },
  perProduct: {
    en: '/product',
  },
  buttonTitle: {
    en: 'Save {saveValue} every month',
  },
  productsAvailable: {
    en: 'Makeup, skincare and wellness products available',
  },
}
